import { BulkRejectAgentVerificationsResult } from '@percent/admin-dashboard/api/actions/agentVerification/agentVerification.types'
import { PBPGetResponse } from '@percent/admin-dashboard/services/pbpResponses'

export const mockBulkRejectAgentVerificationsResponse: PBPGetResponse<BulkRejectAgentVerificationsResult> = {
  data: {
    batchId: '3f1c2b7e-59a4-4b6c-9d21-2f0a8c4d7e11',
    total: 2
  },
  object: 'agent_verification_bulk_reject_request'
}
